import { UIHeading2, UIHeading3 } from '@cian/ui-kit/typography';
import cn from 'classnames';
import * as React from 'react';

import * as styles from './styles.css';
import { Discount } from '../Discount';

interface IPriceProps {
  className?: string;
  isCompact?: boolean;
  /* Цена (с учетом скидки, если скидка есть) */
  price: string;
  /* Цена до применения скидки */
  originalPrice?: string | null;
  /* Размер скидки в % */
  discountPercent?: string | null;
}

export const Price = ({ className, price, originalPrice, discountPercent, isCompact }: IPriceProps) => {
  const showDiscount = originalPrice && discountPercent;
  const Heading = isCompact ? UIHeading3 : UIHeading2;

  return (
    <div className={cn(styles['price-container'], className)}>
      <Heading data-testid="price">{price}</Heading>
      {showDiscount && (
        <div className={styles['discount']} data-testid="discount">
          <Discount originalPrice={originalPrice} discountPercent={discountPercent} isCompact={isCompact} />
        </div>
      )}
    </div>
  );
};
